export default "__VITE_ASSET__DWqjQCPV__"